import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import acumaticaHelpers from '../../helpers/acumatica';
import AcumaticaUploadForm from './AcumaticaUploadForm';
import AcumaticaUploadTable from './AcumaticaUploadTable';

function AcumaticaUpload(props) {

    const [file, setFile] = useState(null);
    const [vendor, setVendor] = useState("");
    const [vendorName, setVendorName] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const [uploads, setUploads] = useState(null);
    const [fileData, setFileData] = useState(null);

    const vendor_options = [
        {value: 'C00299' , name: 'Walmart Fulfillment Center'},
    ];

    const getUploads = async () => {
        props.setLoading(true);
        const uploads = await acumaticaHelpers.getUploads(props.company, props.token);
        setUploads(uploads);
        props.setLoading(false);
    };

    useEffect(() => {
        getUploads();
    }, []);

    useEffect(() => {
        const selectedVendor = vendor_options.find(option => option.value === vendor);
        setVendorName(selectedVendor ? selectedVendor.name : ""); 
    }, [vendor]);

    
    const buttonRef = React.createRef();
    const handleOpenDialog = (e) => {
        if (buttonRef.current) {
            buttonRef.current.open(e);
        };
    };

    const handleRemoveFile = (e) => {
        if (buttonRef.current) {
            buttonRef.current.removeFile(e);
            setFile(null);
        };
    };

    const formatUpload = (vendor, data) => {
        const dataArray = [];
        try {
            if (vendor === 'C00299') {
                data.forEach(row =>{
                    let d = row.data;
                    const order = {
                        OrderType: 'SO',
                        VendorCode: vendor,
                        Date: d.ORDER_PLACED_DT,
                        RequestedOn: d.ORDER_PLACED_DT,
                        CustomerOrderNumber: d.PURCHASE_ORDER_NUM,
                        ExternalRef: d.SALES_ORDER_NUM,
                        InventoryID: d.VENDOR_SKU,
                        Quantity: d.QUANTITY,
                        UnitPrice: d.GMV_AMT,
                        City: d.SHIP_TO_CITY,
                        State: d.SHIP_TO_ST,
                        ZipCode: d.SHIP_TO_ZIP_CD
                    };

                    Object.entries(order).forEach(([key, value]) => {
                        if (value === undefined || value === "") {
                            throw new Error(`Missing required field: ${key}`);
                        };
                    });
                    dataArray.push(order);
                });
                return dataArray;
            } else {
                setFile(null);
                setFileData(null);
                throw new Error('Not a valid customer.');
            }; 
        } catch(err) {
            console.log(err);
            window.alert(err);
            return false;
        };
    };

    const handleOnFileLoad = (data, file) => {
        setFile(file);
        setSuccess(false);
        const formattedData = formatUpload(vendor, data);
        if(!formattedData) {
            setFile(null);
            return;
        };
        setFileData(formattedData);
    };

    const handleOnError = (err, file) => {
        console.log(err);
        setError(`Error Uploading Order File: ${file.name}`);
    };

    const uploadFile = async () => {
        props.setLoading(true);
        try {
            const res = await uploadHelper();
            if (res.data.fail.length) {
                const failed_pos = res.data.fail.map((obj) => obj.CustomerOrderNumber);
                return window.alert(`Successful Uploads: ${res.data.success.length}\nFailed Uploads: ${res.data.fail.length}\nPO Number(s) of Failed Orders: ${failed_pos.join(', ')}`);
            }
            else {
                return window.alert(`Successful Uploads: ${res.data.success.length || 0}\nFailed Uploads: ${res.data.fail.length || 0}`);
            };
        } catch (err) {
            console.log('uploadFile error: ', err);
        } finally {
            getUploads();
            setVendor("");
            setFileData(null);
            props.setLoading(false);
        };
    };

    const uploadHelper = async() => {
        const body = {
            orders: fileData,
            user: props.user.attributes.name, 
            file_name: file.name,
            vendor_name: vendorName
        };
        try {
            return await acumaticaHelpers.createOrders(body, props.company, props.token);
        } catch (err) {
            console.log(err)
        };
    };

    return (
        <Box display = "flex" flexDirection = "column" className = {props.isMobile ? "mobile-top" : "desktop-top"}>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{paddingLeft: 3}}>
                <h1>Acumatica Order Uploads</h1> 
                <p>Each line will be uploaded as its own sales order.</p>
                <AcumaticaUploadForm
                    file = {file}
                    uploads = {uploads}
                    setFile = {setFile}
                    company = {props.company}
                    token = {props.token}
                    user = {props.user}
                    warehouse = {props.warehouse}
                    toast = {props.toast}
                    vendor = {vendor}
                    loading = {props.isLoading}
                    setVendor = {setVendor}
                    vendorName = {vendorName}
                    vendor_options = {vendor_options}
                    handleOnFileLoad = {handleOnFileLoad}
                    handleOnError = {handleOnError}
                    uploadFile = {uploadFile}
                    handleOpenDialog = {handleOpenDialog}
                    handleRemoveFile = {handleRemoveFile}
                    buttonRef = {buttonRef}
                 />
                { uploads ? 
                    <AcumaticaUploadTable 
                        isMobile = {props.isMobile}
                        uploads = {uploads}
                    />
                : null }
                
            </Box>
        </Box>
    )
}

export default AcumaticaUpload;